module.exports = __webpack_public_path__ + "static/media/img_9.5975b974.png";